export enum CommissionType {
  None = 'None',
  FixedFee = 'FixedFee',
  PercentageFinalFee = 'PercentageFinalFee',
  PercentageProfit = 'PercentageProfit',
}
